import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { useI18n } from '@/composables/use-i18n';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { HistoryService } from '@/services/history/service/history.service';
import { useRoute, useRouter } from 'vue-router/composables';
import { useDisposes } from '@analytics/shared/composables/use-disposes';
import { Tooltip } from 'element-ui';
import { HistoryItem } from '../../../services/history/type/history.type';
import '@patsnap-ui/icon/assets/solid/Menu3.svg';
import '@patsnap-ui/icon/assets/solid/info.svg';
import SvgIcon from '@analytics/shared/components/SvgIcon.vue';
import IconCopilot from '@/presentation/components/icons/IconCopilot.vue';
import IconHistoryMenuClose from '@/presentation/components/icons/IconHistoryMenuClose.vue';
import IconHistoryMenuOpen from '@/presentation/components/icons/IconHistoryMenuOpen.vue';
import _ from 'lodash';
import ClickOutside from 'vue-click-outside';
import {
    HISTORY_DEFAULT_PAGE,
    HISTORY_LIST_LIMIT,
    OPEN_DELAY,
    HISTORY_TYPE_MAP,
    PATH_MAP,
} from '@/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'History',
  setup(__props) {

const TRIGGER_NEXT_PAGE_DISTANCE = 50;
const TRIGGER_NEXT_PAGE_THROTTLED_TIME = 800;

const vClickOutside = ClickOutside;
const { disposes } = useDisposes();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const historyListRef = ref();

const taskId = computed(() => route.query.taskId as string);

const historyService = injectService<HistoryService>(HistoryService);
const historyState = ref(historyService.getModelData());

disposes.push(
    historyService.onStatesChange(states => (historyState.value = states)),
);

historyService.getHistoryList({
    page: HISTORY_DEFAULT_PAGE,
    limit: HISTORY_LIST_LIMIT,
});

function handleHistoryMenu(showHistoryList: boolean) {
    historyService.toggleHistoryList(showHistoryList);
}

function handleHistoryItem(item: HistoryItem) {
    if (!item.isRead) {
        historyService.putHistoryRead(item.taskId);
    }
    if (taskId.value === item.taskId) return;

    const pathKey = PATH_MAP[item.type];
    const path = `/${ pathKey }`;
    router.push({ path, query: { taskId: item.taskId } });
}

function handleScroll() {
    if (!historyListRef.value) return;

    const historyList = historyListRef.value as HTMLElement;
    const { scrollTop, scrollHeight, clientHeight } = historyList;

    if (scrollTop + clientHeight >= scrollHeight - TRIGGER_NEXT_PAGE_DISTANCE) {
        historyService.getNextPageHistory();
    }
}

const handleScrollThrottled = _.throttle(
    handleScroll,
    TRIGGER_NEXT_PAGE_THROTTLED_TIME,
);

function handleGoHome() {
    router.push({ path: '/' });
}

function handleClickOutside() {
    historyService.toggleHistoryList(false);
}

return { __sfc: true,TRIGGER_NEXT_PAGE_DISTANCE, TRIGGER_NEXT_PAGE_THROTTLED_TIME, vClickOutside, disposes, route, router, t, historyListRef, taskId, historyService, historyState, handleHistoryMenu, handleHistoryItem, handleScroll, handleScrollThrottled, handleGoHome, handleClickOutside, Tooltip, SvgIcon, IconCopilot, IconHistoryMenuClose, IconHistoryMenuOpen, OPEN_DELAY, HISTORY_TYPE_MAP }
}

})